import * as Yup from 'yup';

export const schema =Yup.object({
    FirstName: Yup.string().required('El nombre es un campo requerido'),
    LastName: Yup.string().required('Los Apellidos son campos requeridos'),   
    //.matches(visaRegEx, ci.invalidErrorMsg),
    phone: Yup.number().typeError("Formato incorrecto de Teléfono").positive("No se debe incluir signos").min(8)
    .required('El teléfono de verificación es requerido'),
        //.matches(visaRegEx, telefono.invalidErrorMsg), 
    position: Yup.string().nullable(),
    information: Yup.string().nullable(),    
    fecha: Yup.date().typeError("Formato incorrecto para la fecha")
    .nullable()
    //.matches(visaRegEx, telf_trab.invalidErrorMsg)
  })


